import Vue from "vue"
import routerGenerate from "./router"
import storeGenerate from "./store"
import globalComponents from "./global/components"
import {globalPrototype, globalPrototypeWithState} from "./global/prototypes"
import middlewareResolve from "./router/middlewares/kernel.js"

globalComponents(Vue)
globalPrototype(Vue)
const router = routerGenerate(Vue)
const store = storeGenerate(router)

// 状態管理が必要はグローバル処理を追加
globalPrototypeWithState(Vue, store, router)
// middleware機能追加
middlewareResolve(router, Vue, store)

new Vue({
  el: "#app",
  router,
  store
})
